import React from "react";

import { Container } from "../../layout/Container/Container";
import { Column, Grid, isFullWidthColumn } from "../Grid";

import { FooterColumn } from "./FooterColumn";
import { IFooterMenu } from "./types";

export const FooterMenu: React.FC<IFooterMenu> = ({ footerColumns }) => {
  return (
    <Grid>
      <Column {...isFullWidthColumn}>
        <Container
          display="flex"
          justifyContent={"stretch"}
          flexWrap={{ LRG: "nowrap", MED: "nowrap", SML: "wrap" }}
        >
          {footerColumns.map((column) => {
            return <FooterColumn key={column._key} {...column} />;
          })}
        </Container>
      </Column>
    </Grid>
  );
};
